/*
TODO:
  - debounce + delay when getting new search content
  - verify mobile functionality
  - sticky mobile filters
*/

((Search, $) => {
  "use strict";

  const dom = {}; // vanilla 

  let totalFilterCount = 0;

  const DESKTOP_BREAKPOINT = 1024;
  const SORT_VALUES = {
   "relevance": "Relevance",
   "price-ascending": "Price: Low to High",
   "price-descending": "Price: High to Low"
  }

  // code to account for iOS nav bar elements
  // https://medium.com/turo-engineering/react-stick-to-bottom-accessible-safari-fixed-bottom-elements-9ed761fbeecb
  const SAFARI_MOBILE_BOTTOM_MENU_HEIGHT = 44;
  let throttleTimer;
  const throttle = (func, delay) => {
    if(throttleTimer) {
      return;
    }

    throttleTimer = setTimeout(() => {
      func();
      throttleTimer = undefined;
    }, delay);
  };

  const cacheFilterGroupOptions = () => {
    dom.filterOptions     = document.querySelectorAll('[data-filter-group]');
    dom.filterInputs      = document.querySelectorAll('[data-filter-input]');
    dom.filterLabels      = document.querySelectorAll('[data-filter-label]');
  };

  const cacheDom = () => {
    dom.filterWrapper     = document.querySelector('[data-search-filters]');
    dom.filterForm        = document.querySelector('[data-filter-form]');
    dom.collectionGrid    = document.querySelector('[data-search-grid]');
    dom.noMatchMessage    = document.querySelector('[data-no-match]');
    dom.mobileActiveBar   = document.querySelector('[data-mobile-active-filters-wrapper]');
    

    dom.filterGroups      = document.querySelectorAll('[data-filters]')
    dom.filterBars        = document.querySelectorAll('[data-active-filters]');
    dom.filterTitles      = document.querySelectorAll('[data-filter-title]');
    dom.sortToggles       = document.querySelectorAll('[data-open-sorting]');
    dom.sortOptions       = document.querySelectorAll('[data-sort-options]');
    
    dom.totalFilterCounts = document.querySelectorAll('[data-total-filter-count]')
    dom.clearFilters      = document.querySelectorAll('[clear-filters]');
    cacheFilterGroupOptions();
  }

  /**
   * When bottom > window.innerHeight, we know that `element` is
   * outside the window bounds. Normally, `position: fixed` keeps the element
   * inside the window bounds.
   */
  const adjustBottomPositionForSafari = (element, offsetBottom) => {
    const {bottom} = element.getBoundingClientRect();
    element.style.bottom = (Math.floor(bottom) > window.innerHeight) 
      ? offsetBottom + SAFARI_MOBILE_BOTTOM_MENU_HEIGHT 
      : offsetBottom;
  };

  const adjustMobileSafariElements = () => { 
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      const mobileFilterOverlay = dom.filterWrapper;
      adjustBottomPositionForSafari(mobileFilterOverlay, 0);
    }
      return;
  }

  const openMobileFilters = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      // expand menus (not working)
      const titles = Array.from(dom.filterTitles);
      const groups = Array.from(dom.filterOptions);
      titles.forEach(title => title.classList.add('active'));
      groups.forEach(group => group.classList.add('active'));

      // open filters
      toggleClass(dom.filterWrapper, 'active');

      // prevent scrolling behind the filter menu
      document.body.classList.add('scroll-lock');
    }
  }

  const closeMobileFilters = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      toggleClass(dom.filterWrapper, 'active');
    }

    // re-enable scrolling
    document.body.classList.remove('scroll-lock');
  }

  const showClearButtons = () => {
    const buttons = Array.from(dom.clearFilters);
    buttons.forEach(btn => {
      btn.classList.add('is-visible');
    })
  }

  const hideClearButtons = () => {
    const buttons = Array.from(dom.clearFilters);
    buttons.forEach(btn => {
      btn.classList.remove('is-visible');
    })
  }

  const clearFilters = () => {
    const filterInputs = Array.from(dom.filterInputs);
    const searchParams = new URLSearchParams(window.location.search);
    const newSearchParams = new URLSearchParams();

    hideClearButtons();
    filterInputs.filter((input) => input.checked).forEach(input => {
      setInputChecked(input, false);
    });
    for (const [key, value] of searchParams.entries()) {
      if (key.indexOf(`filter`) === 0) continue;
      
      newSearchParams.append(key, value);
    }

    const filterBars = Array.from(dom.filterBars);
    filterBars.forEach((bar) => {
      bar.replaceChildren();
    });
    
    updateSearchParams(newSearchParams);
  }

  const clearPriceFilters = () => {
    const priceFilterInputs = Array.from(document.querySelectorAll(`.filter-group__options--price [data-filter-input]`));
    const searchParams = new URLSearchParams(window.location.search);
    const newSearchParams = new URLSearchParams();

    priceFilterInputs.forEach(input => setInputChecked(input, false));
    for (const [key, value] of searchParams.entries()) {
      if (key.indexOf(`filter.v.price`) === 0) continue;
      
      newSearchParams.append(key, value);
    }
    updateSearchParams(newSearchParams);

    Array.from(document.querySelectorAll(`[data-filter-active][data-filter-price]`)).forEach((filter) => filter.remove());
  };
 
  const toggleClass = (element, className) => {
    if (element.classList.contains(className)) {
      element.classList.remove(className)
    } else {
      element.classList.add(className)
    }
  }

  const closeSortMenus = () => {
    const allSortDropdowns = Array.from(dom.sortOptions);
    const allSortToggles = Array.from(dom.sortToggles);
    const allSortMenus = allSortDropdowns.concat(allSortToggles);

    allSortMenus.forEach(item => {
      item.classList.remove('active');
    })
  }

  const closeFilterMenus = () => {
    const allFilterMenus = Array.from(dom.filterOptions);

    allFilterMenus.forEach(menu =>  {
      menu.parentElement.firstElementChild.classList.remove('active'); // title
      menu.classList.remove('active');
    });
  }

  const closeAllDropdowns = () => {
    closeSortMenus();
    closeFilterMenus();
  }

  const updateFilterCounts = () => {
    const filterGroups = Array.from(dom.filterGroups);
    let totalCount = 0;

    filterGroups.forEach(group => {
      let localCount = 0;

      const checkedInputs = Array.from(group.querySelectorAll('input:checked'));
      localCount += checkedInputs.length;
      totalCount += checkedInputs.length;

      const countSpan = group.querySelector('[data-filter-title] span');
      countSpan.textContent = localCount > 0 ? `(${localCount})` : ''
      
    });

    // update totalCount
    const totalCountSpans = Array.from(dom.totalFilterCounts);
    totalCountSpans.forEach(span => {
      span.textContent = totalCount > 0 ? `(${totalCount})` : '';
    });
    totalFilterCount = totalCount; // used only to adjust margin of mobile collection grid
    
  }

  const toggleActiveFilters = () => {
    const activeInputs = Array.from(document.querySelectorAll('[data-filter-form] input:checked'));
    const filterBars = Array.from(dom.filterBars);
    if (dom.mobileActiveBar) {
      if (activeInputs.length === 0) {
        filterBars.forEach((bar) => (bar.innerHTML = '')); // clear out filters
        dom.mobileActiveBar.style.display = 'none'; // hide mobile filter bar
      } else {
        dom.mobileActiveBar.style.display = 'flex'; // show mobile filter bar
      }
    }
  }

  const updateSearchParams = (searchParams) => {
    searchParams.delete(`page`);
    const newUrl = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}${window.location.hash}`;
    window.history.pushState(null, newUrl, newUrl);
    updateFilterState();
    renderNewSearchContent();
  }

  const renderNewSearchContent = window.Helpers.debounce(async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const searchResults = document.querySelector(`.search-results`);
    searchResults.classList.add(`is-loading`);
    const searchSection = searchResults.closest(`.shopify-section`);
    searchParams.set(`section_id`, `${searchSection.getAttribute('id').replace('shopify-section-','')}`);
    const response = await fetch(`${window.location.pathname}?${searchParams.toString()}`);
    const htmlString = await response.text();

    const newContent = document.createElement(`div`);
    newContent.innerHTML = htmlString.trim();
    
    const newSearchResults = newContent.querySelector(`.search-results`);
    searchResults.replaceWith(newSearchResults);

    Array.from((newContent.querySelectorAll(`.filter-group`))).forEach((newFilterGroup) => {
      const filterGroup = document.querySelector(`.filter-group[data-filter-param="${newFilterGroup.dataset.filterParam}"]`);
      if (!filterGroup) return;

      const filterGroupOptions = filterGroup.querySelector(`[data-filter-group]`);
      const newFilterGroupOptions = newFilterGroup.querySelector(`[data-filter-group]`);
      if (filterGroupOptions.classList.contains(`active`)) {
        newFilterGroupOptions.classList.add(`active`);
      }

      filterGroupOptions.replaceWith(newFilterGroupOptions);

      cacheFilterGroupOptions();
    });

    if (myLazyLoad) {
      myLazyLoad.update();
    }
    if (window.ProductTileOptions) {
      window.ProductTileOptions.init();
    }

    updateFilterState();
  }, 1000);

  const setInputChecked = (input, isChecked) => {
    const label = input.closest(`label`);
    input.checked = isChecked;
    if (isChecked) {
      label.classList.add(`selected`);
    } else {
      label.classList.remove(`selected`);
    }
  };

  const addFilterButton = (param, value) => {
    if (!param || !value) return;
    const filterBars = Array.from(dom.filterBars);

    filterBars.forEach(bar =>  {
      const button = document.createElement('button');
      const span = document.createElement('span');
      span.textContent = value;
      button.appendChild(span);
      button.setAttribute('data-filter-param', param);
      button.setAttribute('data-filter-value', value);
      button.setAttribute('data-filter-active', ``);
      bar.appendChild(button);
    });
    addFilter(param, value);
    showClearButtons();
    scrollToFilterTop();
  };

  const addPriceFilterButton = ({ minParam, minValue, maxParam, maxValue }) => {
    if (!minParam && !minValue && !maxParam && !maxVal) return;
    const filterBars = Array.from(dom.filterBars);

    filterBars.forEach(bar =>  {
      const button = document.createElement('button');
      const span = document.createElement('span');

      let minContent = ``;
      if (minParam && minValue) {
        minContent = theme.Currency.formatMoney(minValue * 100, window.StyleHatch.currencyFormat).replace(`.00`, ``);;
        button.setAttribute('data-filter-min-param', minParam);
        button.setAttribute('data-filter-min-value', minValue);
      }
      let maxContent = ``;
      if (maxParam && maxValue) {
        maxContent = maxValue;
        button.setAttribute('data-filter-max-param', maxParam);
        button.setAttribute('data-filter-max-value', maxValue);
      }

      if (minContent) {
        const minMoney = theme.Currency.formatMoney(minValue * 100, window.StyleHatch.currencyFormat).replace(`.00`, ``);
        if (!maxContent) {
          minContent = `Over ${minMoney}`;
        }
      }
      if (maxContent) {
        const maxMoney = theme.Currency.formatMoney(maxValue * 100, window.StyleHatch.currencyFormat).replace(`.00`, ``);
        if (!minContent) {
          maxContent = `Under ${maxMoney}`;
        } else {
          maxContent = ` - ${maxMoney}`;
        }
      }

      span.textContent = `${minContent}${maxContent}`;
      button.setAttribute('data-filter-active', ``);
      button.setAttribute('data-filter-price', ``);
      button.appendChild(span);
      bar.appendChild(button);
    });
    if (minParam && minValue && maxParam && maxValue) {
      addFilter(minParam, minValue, maxParam, maxValue);
    } else if (minParam && minValue) {
      addFilter(minParam, minValue);
    } else if (maxParam && maxValue) {
      addFilter(maxParam, maxValue);
    }
    showClearButtons();
    scrollToFilterTop();
  };

  const addFilter = (param1, value1, param2, value2) => {
    let filterSelector = `${param1}=${value1}`;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.append(param1, value1);
    if (param2 && value2) {
      filterSelector = `${filterSelector}&${param2}=${value2}`;
      searchParams.append(param2, value2);
    }
    const filterInputs = Array.from(document.querySelectorAll(`[data-filter-query="${filterSelector}"]`));
    filterInputs.forEach((input) => {
      setInputChecked(input, true);
    });
    updateSearchParams(searchParams);
  };

  const removeFilterButton = (param, value) => {
    if (!param || !value) return;
    const filterBars = Array.from(dom.filterBars);
    filterBars.forEach(bar => {
      const buttons = Array.from(bar.querySelectorAll(`button[data-filter-value="${value}"][data-filter-param="${param}"]`));
      buttons.forEach(button => {
        button.remove();
      })
    });
    removeFilter(param, value);
    if (filterBars[0].children.length <= 0) {
      hideClearButtons();
    }
  }

  const removePriceFilterButton = ({ minParam, minValue, maxParam, maxValue }) => {
    const filterBars = Array.from(dom.filterBars);
    filterBars.forEach((bar) => {
      let queryString = ``;
      if (minParam && minValue) {
        queryString = `[data-filter-min-param="${minParam}"][data-filter-min-value="${ minValue }"]`;
        
      }
      if (maxParam && maxValue) {
        queryString = `${queryString}[data-filter-max-param="${maxParam}"][data-filter-max-value="${ maxValue }"]`;
      }
      const button = bar.querySelector(queryString);
      button.remove();
    });
    if (minParam && minValue && maxParam && maxValue) {
      removeFilter(minParam, minValue, maxParam, maxValue);
    } else if (minParam && minValue) {
      removeFilter(minParam, minValue);
    } else if (maxParam && maxValue) {
      removeFilter(maxParam, maxValue);
    }
    if (filterBars[0].children.length <= 0) {
      hideClearButtons();
    }
  }

  const removeFilter = (param1, value1, param2, value2) => {
    let filterSelector = `${param1}=${value1}`;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(param1, value1);
    if (param2 && value2) {
      filterSelector = `${filterSelector}&${param2}=${value2}`;
      searchParams.delete(param2, value2);
    }
    const filterInputs = Array.from(document.querySelectorAll(`[data-filter-query="${filterSelector}"]`));
    filterInputs.forEach((input) => {
      setInputChecked(input, false);
    });
    updateSearchParams(searchParams);
  }

  const setStickyFilters = () => {
    const promoBar        = document.getElementById('shopify-section-promos');
    const promoPosition   = getComputedStyle(promoBar).position;
    const siteHeader      = document.getElementById('shopify-section-header');
    const stickyFilters   = (window.innerWidth < DESKTOP_BREAKPOINT) 
      ? document.querySelector('[data-sticky-filter-mobile]') 
      : document.querySelector('[data-sticky-filter-desktop]');

    const promoBarOffset     = (promoPosition === 'sticky' || promoPosition === 'fixed')
      ? promoBar.offsetHeight
      : 0;
      
    if(stickyFilters) {
      stickyFilters.style.top = `${promoBarOffset + siteHeader.offsetHeight}px`;
    }
  }

  const scrollToFilterTop = () => {
    const promoBar        = document.getElementById('shopify-section-promos');
    const siteHeader      = document.getElementById('shopify-section-header');
    const filterTop       = promoBar.offsetHeight + siteHeader.offsetHeight;

    if(window.scrollY > filterTop) {
      window.scrollTo(0, filterTop);
    }
  }

  const adjustProductGridForActiveMobileFilters = () => {
    if (!dom.mobileActiveBar) {
      return;
    }
    const activeBarHeight = dom.mobileActiveBar.offsetHeight;
    const collectionGrid = document.querySelector('.collection.search-results');

    collectionGrid.style.marginTop = (totalFilterCount > 0) ? `${activeBarHeight + 20}px` : '0px';
  }

  const setCurrentSortText = () => {
    // https://gist.github.com/carolineschnapp/11352987#file-gistfile1-html
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has(`sort_by`)) return;
    const currentSort = searchParams.get(`sort_by`);
    
    // set sort menu text
    const sortSpans = Array.from(document.querySelectorAll('[data-current-sort]'));
    sortSpans.forEach(span => span.textContent = SORT_VALUES[currentSort])

    // remove duplicated option
    const sortOptions = Array.from(document.querySelectorAll('[data-sort-value]'));
    sortOptions.forEach(option => {
      if(option.getAttribute('data-sort-value') === currentSort) {
        option.classList.add(`visually-hidden`);
      } else {
        option.classList.remove(`visually-hidden`);
      }
    });
  }

  const updateFilterState = () => {
    updateFilterCounts();
    toggleActiveFilters();
    adjustProductGridForActiveMobileFilters();
  }

  const bindUiActions = () => {

    let resizeTimer;
    window.addEventListener('resize', (event) => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setStickyFilters();
      }, 250);
    });

    window.addEventListener('scroll', throttle(adjustMobileSafariElements, 150));

    // click listener
    document.addEventListener('click', event => {
      const el = event.target;

      // OPEN MOBILE FILTERS
      if(el.matches('[data-open-mobile-filters]') 
        || (el.parentElement && el.parentElement.matches('[data-open-mobile-filters]'))) {
        openMobileFilters();
      }

      // CLOSE MOBILE FILTERS
      if(el.matches('[data-apply-mobile-filters]') || el.matches('[data-close-mobile-filters]')) {
        closeMobileFilters();
      }

      // OPEN FILTER DROPDOWNS
      if(el.matches('.filter-group__title')) {
        const optionsList = el.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      } 
      
      // CLOSE DROPDOWNS WHEN SOMETHING ELSE IS CLICKED
      if (!el.matches('.filter-group__options')
        && !el.matches('.filter-group__options *')
        && !el.matches('[data-open-sorting]')
        && !el.matches('[data-open-sorting] *')
        && !el.matches('[data-sort-options]')
        && !el.matches('[data-sort-options] *')) {
        closeAllDropdowns();
      }

      // CLEAR FILTERS (+ account for buttons with spans)
      if(el.matches('[clear-filters]') 
        || (el.parentElement && el.parentElement.matches('[clear-filters]'))) {
        clearFilters();
      }

      // OPEN SORT DROPDOWN (MOBILE)
      if(el.matches('.mobile-control-panel [data-open-sorting]')) {
        const optionsList = el.parentElement.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      } else if (el.parentElement && el.parentElement.matches('.mobile-control-panel [data-open-sorting]')) {
        const optionsList = el.parentElement.parentElement.nextElementSibling;
        toggleClass(el.parentElement, 'active');
        toggleClass(optionsList, 'active');
        return;
      }

      // OPEN SORT DROPDOWN (DESKTOP)
      if(el.matches('.sort-bar [data-open-sorting]')) {
        const optionsList = el.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      } else if (el.parentElement && el.parentElement.matches('.sort-bar [data-open-sorting]')) {
        const optionsList = el.parentElement.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      }

      // Update Sort
      if(el.matches('[data-sort-value]')) {
        const sortValue = el.getAttribute('data-sort-value');
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(`sort_by`, sortValue);
        updateSearchParams(searchParams);
        setCurrentSortText();
        closeSortMenus();
      }

      if (el.matches(`[data-filter-active`)) {
        if (el.matches(`[data-filter-price]`)) {
          removePriceFilterButton({
            minParam: el.dataset.filterMinParam,
            minValue: el.dataset.filterMinValue,
            maxParam: el.dataset.filterMaxParam,
            maxValue: el.dataset.filterMaxValue
          });
        } else {
          removeFilterButton(el.dataset.filterParam, el.dataset.filterValue);
        }
      }
    });

    document.addEventListener('change', event => {
      const el = event.target;

      if (el.matches(`[data-filter-input]`)) {
        const newParams = new URLSearchParams(el.dataset.filterQuery);
        const priceFilters = {};
        for (let [key, val] of newParams.entries()) {
          if (key.includes(`price`)) {
            if (key.includes(`gte`)) {
              priceFilters.minParam = key;
              priceFilters.minValue = val;
            } else {
              priceFilters.maxParam = key;
              priceFilters.maxValue = val;
            }
          } else if (el.checked) {
            addFilterButton(key, val);
          } else {
            removeFilterButton(key, val);
          }
        }
        if (Object.keys(priceFilters).length > 0) {
          if (el.checked) {
            clearPriceFilters();
            addPriceFilterButton(priceFilters);
          } else {
            removePriceFilterButton(priceFilters);
          }
        }
      }
    });
  }

  const init = () => {
    setStickyFilters();
    setCurrentSortText();
    cacheDom();
    updateFilterState();
    bindUiActions();
  }

  Search.init = init;
})((window.Search = window.Search || {}), jQuery);